export default {
  header: '',
  loader: '',
  item: item => JSON.stringify(item),
};
